import { apiFetch } from "../utils/apiFetch";
import React from "react";

const ClassDeletePopup = ({
  setDeletePopup,
  classTitle,
  classId,
  setClasses,
}) => {
  const handleDeleteClass = async (classId) => {
    try {
      const response = await apiFetch(
        `${process.env.API_URL}/api/classes/${classId}/delete`,
        {
          method: "DELETE",
          },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to delete class");
      }

      setClasses((prev) =>
        prev.filter((cl) => String(cl._id) !== String(classId)),
      );
      setDeletePopup(false);
    } catch (err) {
      alert(err.message);
    }
  };
  return (
    <div
      onClick={() => setDeletePopup(false)}
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog" aria-modal="true" aria-label="Delete class"
        className="mx-4 w-full max-w-md space-y-4 rounded-lg bg-white p-6 text-gray-900 shadow-xl"
      >
        <h2 className="text-lg font-semibold">Delete class?</h2>
        <p className="break-words text-sm text-gray-600">{`Are you sure you want to delete "${classTitle}"?`}</p>
        <button className="mr-3 h-10 rounded-md border border-gray-300 px-4 text-sm font-medium" onClick={() => setDeletePopup(false)}>
          Cancel
        </button>
        <button
          className="h-10 rounded-md bg-red-700 px-4 text-sm font-semibold text-white hover:bg-red-800"
          onClick={() => handleDeleteClass(classId)}
        >
          Delete class
        </button>
      </div>
    </div>
  );
};

export default ClassDeletePopup;
